import { useEffect } from 'react'

function useGlobalFunction(name, fn) {
  useEffect(() => {
    window[name] = fn
  }, [fn, name])
}

export default useGlobalFunction
